/* import __COLOCATED_TEMPLATE__ from './pane.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import Component from '@glimmer/component';
import { useResource } from 'ember-resources';
import NavigableSelection from 'embercom/components/inbox2/common/navigable-selection-resource';
import { type ChildAction } from 'embercom/objects/inbox/command-k/action';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type AssignToAction from 'embercom/objects/inbox/command-k/assign-to';
import type CommandKService from 'embercom/services/command-k';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import { type CommandKPaneComponentArgs } from 'embercom/lib/inbox2/command-k-types';

interface Signature {
  Args: CommandKPaneComponentArgs<AssignToAction>;
}

export default class AssignToPaneComponent extends Component<Signature> {
  @service declare commandK: CommandKService;
  @service declare session: Session;
  @tracked query = '';

  selection = useResource(this, NavigableSelection, () => ({
    items: this.items,
    isCommandKVisible: this.commandK.isVisible,
  }));

  get items(): Array<ChildAction> {
    return this.args.actionItem.buildResults(this.query);
  }

  @action search(query: string) {
    this.query = query;
    this.commandK.trackSearch({
      query: this.query,
      number_of_results: this.items.length,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::AssignTo::Pane': typeof AssignToPaneComponent;
    'inbox2/command-k/assign-to/pane': typeof AssignToPaneComponent;
  }
}
